<template>
    <div>
        <div class="evaluation-tips" v-if="isSociety">
            <p class="point">使用说明：</p>
            <ul>
                <li><i></i><span class="em">建议薪资</span>和<span class="em">期望薪资</span>为必填项，建议薪资和期望薪资请面试官填写年薪</li>
                <li><i></i>评分标准作为参考，统一各组面试标准。面试者是否通过面试<span class="em">由面试官根据实际情况决定</span>；</li>
                <li><i></i>以S\A\B\C\D数量作为面试者定级的参考。面试官给出建议薪资，最终<span class="em">定级由外包管理委员会综合面试官提供的面试评估决定</span>。</li>
            </ul>
            <p class="point" style="margin-top: 10px;">面试记录：</p>
            <ul>
                <li><i></i>填写面试过程中评级的原因或者面试题目和答案；</li>
            </ul>
            <p class="point" style="margin-top: 10px;">参考说明：</p>
            <ul>
                <li><i></i>主属性采用SABCD的方式评价。</li>
                <li><i></i>表格中提供的题目以及解答为<span class="em">参考题目以及参考解答，请勿直接使用</span>，关键点已经用对应的颜色标明<span class="orange">S橙色</span>、<span class="yellow">A黄色</span>、<span class="blue">B蓝色</span>、<span class="green">C绿色</span>、<span class="black">D黑色</span></li>
                <li><i></i>评级中分值表示的是培养后外包所能到达的绩效水平（例如：预计王三同学在培养后该项能力可以达到S绩效同学的预期，给出S即可）</li>
            </ul>
            <p class="point em" style="margin-top: 10px;"> 通过方式参考：</p>
            <ul>
                <li>1. 所有必要属性评级为B,或者大于等于B；</li>
                <li>2. 游戏理解S，其他属性要求可以酌情降低，允许有一个C；</li>
                <li>3. 计算机基础和算法编程取最高分作为计算机综合分，计算机综合分为A或者以上，其他非计算机相关属性要求可以酌情降低，允许有一个C。</li>
            </ul>
        </div>
        <div class="evaluation-tips" v-else>
            <p class="point" style="margin-top: 10px;"> 使用说明：</p>
            <ul>
                <li><i></i><span class="em">期望描述</span>为必填项；</li>
                <li><i></i>评分标准作为参考，统一各组面试标准。面试者是否通过面试<span class="em">由面试官根据实际情况决定</span>；</li>
                <li><i></i>以S\A\B\C\D数量作为面试者定级的参考。面试官给出建议薪资，最终<span class="em">定级由外包管理委员会综合面试官提供的面试评估决定</span>。</li>
            </ul>
            <p class="point" style="margin-top: 10px;">面试记录：</p>
            <ul>
                <li><i></i>填写面试过程中评级的原因或者面试题目和答案；</li>
            </ul>
            <p class="point" style="margin-top: 10px;">参考说明：</p>
            <ul>
                <li><i></i>主属性采用SABCD的方式评价；</li>
                <li><i></i>表格中提供的题目以及解答为<span class="em">参考题目以及参考解答，请勿直接使用</span>，关键点已经用对应的颜色标明<span class="orange">S橙色</span>、<span class="yellow">A黄色</span>、<span class="blue">B蓝色</span>、<span class="green">C绿色</span>、<span class="black">D黑色</span></li>
                <li><i></i>评级中分值表示的是培养后外包所能到达的绩效水平（例如：预计王三同学在培养后该项能力可以达到S绩效同学的预期，给出S即可）</li>
            </ul>
            <p class="point em" style="margin-top: 10px;"> 通过方式参考：</p>
            <ul>
                <li>1. 所有必要属性评级为B,或者大于等于B；</li>
                <li>2. 游戏理解S，其他属性要求可以酌情降低，允许有一个C；</li>
                <li>3. 计算机基础和算法编程取最高分作为计算机综合分，计算机综合分为A或者以上，其他非计算机相关属性要求可以酌情降低，允许有一个C。</li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            isSociety: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
<style lang="scss">
    .evaluation-tips{
        background: #f3fefd;
        border: 1px solid #abe5dc;
        margin: 30px 0;
        padding: 15px;
        .point{
            font-weight: bold;
            margin: 5px 0;
        }
        li{
            color: #333333;
            padding: 5px 0;
            i{
                display: inline-block;
                width: 6px;
                height: 6px;
                background: #27c9b4;
                margin-right: 10px;
                border-radius: 100%;
                position: relative;
                top: -2px;
            }
        }
        .em{
            color: #ff0000;
        }
    }
</style>



// WEBPACK FOOTER //
// society-form-tips.vue?75bdc37e